<template>
  <section class="poster-with-image">
    <img :src="src" :alt="alt" class="img-laptop" />
    <div class="content">
      <h2 v-html="headline" />
      <img :src="src" :alt="alt" class="img-mobile" />
      <p v-html="paragraph" />
    </div>
  </section>
</template>

<script>
export default {
  props: {
    headline: String,
    paragraph: String,
    src: String,
    alt: String,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.poster-with-image {
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  padding: 80px 0;
}

.content {
  max-width: 560px;
  height: fit-content;
  padding: 40px 60px;
  margin-top: 40px;
  border-radius: $border-radius;
  box-shadow: 0 0 11px 0 rgba(18, 45, 81, 0.08);
  position: relative;
  left: 100px;
  background-color: $white;
}

img {
  position: relative;
  right: 100px;
  max-width: 776px;
}

.img-mobile {
  display: none;
}

h2 {
  margin-bottom: 12px;
}

@media (max-width: $page-laptop-large-breakpoint) {
  .content {
    padding: 30px 40px;
    margin-top: 30px;
  }

  h2 {
    font-size: $font-size-headline-medium;
  }

  img {
    max-width: 650px;
    max-height: 335px;
  }
}

@media (max-width: $page-laptop-breakpoint) {
  .content {
    padding: 20px 25px;
    margin-top: 25px;
  }

  h2 {
    font-size: $font-size-headline-small;
    line-height: 30px;
  }

  p {
    font-size: $font-size-base;
  }

  img {
    max-width: 550px;
  }
}

@media (max-width: $header-breakpoint) {
  .img-laptop {
    display: none;
  }

  .img-mobile {
    display: block;
    margin: 15px 0 30px 0;
    max-width: 600px;
    right: 0;
  }

  .content {
    height: fit-content;
    padding: 0 15px;
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    left: 0;
    background-color: none;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  h2 {
    font-size: $font-size-headline-medium;
    line-height: 40px;
    text-align: center;
  }

  p {
    font-size: $font-size-large;
    line-height: 30px;
    max-width: $page-table-breakpoint;
  }
}

@media (max-width: $page-table-breakpoint) {
  .img-mobile {
    max-width: 100%;
  }

  .poster-with-image {
    padding-bottom: 40px;
  }

  .content {
    max-width: $page-mobile-large-breakpoint;
  }

  p {
    font-size: $font-size-base;
  }
}
</style>
